import VerticalBarChart from '../../reusable/VerticalBarChart';
import { getTestScoresDetails } from '../../../services/dataQcDetailsService';
import { darkGreenBarColor } from '../../../theme/xq-custom-theme';
import WithDataWrapper from '../../reusable/WithDataWrapper';
import { TestScoresDetails } from '../../../interfaces/DataQcInterface';
import { AxiosResponse } from 'axios';
import CustomDivider from '../../reusable/CustomDivider';
import { formatNumber } from '../../../utils';
import useSchools from '../../hooks/useSchools';

import './TestScoresDrawerContainer.css';

import './TestScoresDrawerContainer.css';

interface TestScoresDetailsProps {
  data: PromiseSettledResult<AxiosResponse<TestScoresDetails>>[];
}

interface ChartData {
  scores: number[];
  labels: string[];
  student_count_not_taken_test: number;
  student_count_taken_test: number;
}

const parseData = (data: PromiseSettledResult<AxiosResponse<TestScoresDetails>>[]) => {

  const props = ['sat', 'act'];

  const parsedDataObject = {
    sat: { scores: [], labels: [], student_count_not_taken_test: 0, student_count_taken_test: 0 } as ChartData | null,
    act: { scores: [], labels: [], student_count_not_taken_test: 0, student_count_taken_test: 0 } as ChartData | null,
  };

  data.forEach((dataResult, index) => {
    let property = props[index];

    switch (property) {
    case 'sat':
    case 'act':
      if (dataResult.status === 'fulfilled' && dataResult.value.data) {
        let scores: number[] = [];
        let labels = new Set<string>();

        dataResult.value.data.ranges.forEach(range => {
          scores.push(range.count);
          labels.add(range.start.toString());
          labels.add(range.end.toString());
        });

        parsedDataObject[property] = {
          scores: scores,
          labels: Array.from(labels),
          student_count_not_taken_test: dataResult.value.data.student_count_not_taken_test ?? 0,
          student_count_taken_test: dataResult.value.data.student_count_taken_test ?? 0,
        };
      } else parsedDataObject[property] = null;
      break;
    }
  });

  return parsedDataObject;
};

export function TestScoresDrawerContent({data}: TestScoresDetailsProps) {
  const { sat, act } = parseData(data);

  return (
    <>
      <div className="drawer-section chart-section">
        <p className="section-title">SAT superscore distribution</p>
        { sat ?
          <>
            <div className="chart-info">
              <p className="chart-title">Students in EOAA cohort: {formatNumber(sat.student_count_taken_test)}</p>
              <p className="chart-sub-title">{formatNumber(sat.student_count_not_taken_test)} did not take SAT</p>
            </div>
            <VerticalBarChart 
              labels={sat.labels} 
              dataSets={[{data: sat.scores, backgroundColor: darkGreenBarColor}]} 
              displayDataLabels={false} 
              dataLabelsFormatter={formatNumber}
              xAxisTitle="SAT superscore"
              yAxisTitle="Number of students"
            />
          </>
          :
          <p>Error occured while fetching "SAT superscore distribution" data!</p>
        }
      </div>

      <CustomDivider orientation="horizontal" />

      <div className="drawer-section chart-section">
        <p className="section-title">ACT superscore distribution</p>
        { act ?
          <>
            <div className="chart-info">
              <p className="chart-title">Students in EOAA cohort: {formatNumber(act.student_count_taken_test)}</p>
              <p className="chart-sub-title">{formatNumber(act.student_count_not_taken_test)} did not take ACT</p>
            </div>
            <VerticalBarChart 
              labels={act.labels} 
              dataSets={[{data: act.scores, backgroundColor: darkGreenBarColor}]} 
              displayDataLabels={false} 
              dataLabelsFormatter={formatNumber}
              xAxisTitle="ACT superscore"
              yAxisTitle="Number of students"
            />
          </>
          :
          <p>Error occured while fetching "ACT superscore distribution" data!</p>
        }
      </div>
    </>
  );
}

const TestScoresDrawerContentWithData = () => {
  
  const { dataQcSchool } = useSchools();

  let fetchData = (eoaId: string, access_token: string) => getTestScoresDetails(eoaId, access_token, dataQcSchool);

  return (
    <WithDataWrapper
      fetchData={fetchData}
      errorMessage="Error occurred while fetching test scores details data!"
      initialState={[]}
      options={{
        dependencies: [dataQcSchool],
        areDependenciesRequired: false
      }}
    >
      {(data) => <TestScoresDrawerContent data={data} />}
    </WithDataWrapper>
  );
};

export default TestScoresDrawerContentWithData;
